'use client';

import React from 'react';
import Link from 'next/link';
import ZemeMark from '@src/v3/assets/svg/zemeMark';
import Icon from '@src/v3/components/coreUI/icon';
import { TEXT_ZEME_URL } from '@src/v3/constants/common';

/**
 * Bar height in px. On desktop the bar rides inside <header>, so the layout's
 * top offset for the explore route has to add this to the nav height; on mobile
 * the explore shell pads its bottom sheet past it. Both read from here.
 */
export const TEXT_ZEME_BANNER_HEIGHT = 40;

/**
 * Full-bleed cross-promo bar pointing renters at TextZeme. Sits above the nav
 * on desktop and at the top of the map shell on mobile.
 *
 * The whole bar is the link so the tap target is the full width rather than
 * just the underlined words. Copy is shortened below `sm` so it never wraps a
 * 40px bar on a narrow phone.
 */
const TextZemeBanner = () => {
  return (
    <Link
      href={TEXT_ZEME_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="Tired of searching yourself? Let TextZeme search for you, for free."
      className="textzeme-banner-gradient group relative flex w-full items-center justify-center gap-2 overflow-hidden px-4 text-white sm:gap-2.5"
      style={{ height: TEXT_ZEME_BANNER_HEIGHT }}
    >
      {/* Solid white mark — a blurred halo behind it just reads as a smudge at
          this size against the bright gradient. */}
      <ZemeMark monochrome className="h-[15px] w-[17px] shrink-0" />

      <span className="truncate text-[13px] font-medium sm:text-sm">
        <span className="text-white/80">
          <span className="sm:hidden">Stop searching yourself,</span>
          <span className="hidden sm:inline">
            Tired of searching yourself?
          </span>
        </span>{' '}
        <span className="font-bold underline decoration-white/60 decoration-2 underline-offset-[3px] transition-colors duration-200 group-hover:decoration-white">
          <span className="sm:hidden">Try TextZeme</span>
          <span className="hidden sm:inline">
            Let TextZeme search for you, for free.
          </span>
        </span>
      </span>

      <span className="shrink-0 transition-transform duration-300 ease-out group-hover:translate-x-1">
        <Icon iconName="arrowRight" iconProps={{ className: 'h-2 w-3' }} />
      </span>
    </Link>
  );
};

export default TextZemeBanner;
